import { useSelector } from 'react-redux';

export const useAppLocale = () => useSelector((state) => state?.user?.currentLocale);
